import { render, staticRenderFns } from "./WhatsappBroadcastCompleted.vue?vue&type=template&id=72d84aec&scoped=true"
import script from "./WhatsappBroadcastCompleted.vue?vue&type=script&lang=js"
export * from "./WhatsappBroadcastCompleted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d84aec",
  null
  
)

export default component.exports